module.exports = __webpack_public_path__ + "img/REC_ENFANT_FEMME_ACTIVE.326399f3.svg";